import React from 'react';

import Header from './../Header/Header'
import Footer from './../Footer/Footer'

// foundation stateless component
const Foundation = () =>
	<div>
		<Header />
		<section class="section">
			<div class="container">
				<h1 class="title">Fundación Jiu Jitsu Argentina</h1>
				<p class="has-text-justified">
					La Fundación <b>Jiu Jitsu Argentina</b> es parte de <b>The Jiu Jitsu Foundation</b>, una organización de artes marciales progresiva que enseña un estilo de Jiu Jitsu mundialmente conocido como Shorinji Kan.
					<br />
					The Jiu Jitsu Foundation cuenta con clubes en varios países, entre los cuales se encuentran: Argentina, Australia, Canadá, Dinamarca, Escocia, España, Estados Unidos, Gales, Inglaterra, Islas Virgenes Británicas, Japón, Kenia, Sudáfrica y Nueva Zelanda.
					<br />
					Muchos principiantes inician la práctica de nuestro estilo como una forma de defensa personal, otros provienen de otras artes marciales y desean ver en que consiste nuestro estilo. Independientemente de sus razones, nuestro objetivo es ayudarlos a lograr sus objetivos mediante trabajo duro y disciplina.
					<br />
					Quienes entrenan con nosotros son una parte integral de nuestra comunidad, la cual esta compuesta por sus estudiantes e instructores.
					<br />
					Nos enorgullecemos de proveer un ambiente amigable e inspirador para la práctica de artes marciales.
				</p>
			</div>
		</section>
		<Footer />
	</div>

export default Foundation;



// WEBPACK FOOTER //
// ./src/components/About/Foundation.js